export class NICEUserStateHistory {

    agentSessionId: number;
    agentStateId: number;
    agentStateName: string;
    duration: number;
    fromAddress: string;
    isNaturalCalling: boolean;
    isOutbound: number;
    mediaTypeId: number;
    mediaTypeName: string;
    outStateDescription: string;
    outStateId: number;
    skillId: number;
    skillName: string;
    startDate: string;
    stateIndex: number;
    stationId: number;
    stationName: string;
    toAddress: string;
    mediaIcon: string;
    durationFmt: string;

    constructor(jsonData?) {
        this.agentSessionId = jsonData.agentSessionId;
        this.agentStateId = jsonData.agentStateId;
        this.agentStateName = jsonData.agentStateName;
        this.duration = jsonData.duration;
        this.fromAddress = jsonData.fromAddress;
        this.isNaturalCalling = jsonData.isNaturalCalling;
        this.isOutbound = jsonData.isOutbound;
        this.mediaTypeId = jsonData.mediaTypeId;
        this.mediaTypeName = jsonData.mediaTypeName;
        this.outStateDescription = jsonData.outStateDescription;
        this.outStateId = jsonData.outStateId;
        this.skillId = jsonData.killId;
        this.skillName = jsonData.skillName;
        this.startDate = jsonData.startDate.replace('T', ' ').replace('.000Z', '');
        this.stateIndex = jsonData.stateIndex;
        this.stationId = jsonData.stationId;
        this.stationName = jsonData.stationName;
        this.toAddress = jsonData.toAddress;
        this.mediaIcon = '';
        if (this.mediaTypeId === 4) {
            if (this.isOutbound === 1) {
                this.mediaIcon = 'phone_forwarded';
            } else {
                this.mediaIcon = 'phone_callback';
            }
        }
        if (this.mediaTypeName === 'Voice Mail') {
            this.mediaIcon = 'voicemail';
        }
        if (this.mediaTypeName === 'E-Mail') {
            this.mediaIcon = 'email';
        }
        if (this.mediaTypeName === 'Chat') {
            this.mediaIcon = 'chat';
        }
        if (this.mediaTypeName === 'Phone Dialer') {
            this.mediaIcon = 'phone_forwarded';
        }
        if (this.mediaTypeName === 'Work Item') {
            this.mediaIcon = 'confirmation_number';
        }
        if (this.mediaTypeName === 'SMS') {
            this.mediaIcon = 'chat';
        }
        if (this.mediaTypeName === 'Social') {
            this.mediaIcon = 'social';
        }
        if (this.mediaTypeName === 'Digital') {
            this.mediaIcon = 'forum';
        }
        let temp = this.duration;
        const H = Math.floor(temp / 3600);
        temp = temp - (H * 3600);
        const M = Math.floor(temp / 60);
        const S = temp - (M * 60);
        let MF = ('0' + M);
        MF = MF.substr(MF.length - 2, 2);
        let SF = ('0' + S);
        SF = SF.substr(SF.length - 2, 2);
        this.durationFmt = H + ':' + MF + ':' + SF;
    }
}
